import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingGatesTypeFilter } from 'shared/selectors/advancedFilters';
import { EBuildingGatesType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const BuildingGatesTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingGatesTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingGatesTypeChange = useCallback(
    (newValue: NonEmptyArray<EBuildingGatesType> | null) => {
      onChange({ action: 'setBuildingGatesType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBuildingGatesTypeChange} />
    </AdvancedFilterRow>
  );
};
